import apiForluz from './api';

export class TransparenciaService {
  getDocumentosTransparencia = async (tipo, Ano, Mes, plano) => {
    const params = {
      tipo,
      Ano,
      Mes,
      plano,
    };
    const response = await apiForluz.get('ObterDocumentosTransparencia', {
      params,
    });
    return response.data.results;
  };

  getFornecedores = async () => {
    const listaFornecedores = await apiForluz.get('ObterFornecedores', {
      params: {
        paginacao: '4',
      },
    });

    return listaFornecedores.data;
  };
}
